export const EVENT_STATS = `
	query stats($event_id: Uint) {
		stats(event_id: $event_id) {
			event_id
			attendee_count
			attendee_count_previous
			attendee_active_count
			attendee_active_count_previous
			attendee_engaged_count
			attendee_engaged_count_previous
			attendee_mobile_count
			attendee_web_count
			attendee_ios_count
			attendee_android_count
			group_count
			group_count_previous
			group_track_count
			group_track_count_previous
			agenda_item_count
			attendance
			attendance_web
			attendance_mobile
			app_versions
			created_at
			updated_at
		}
	}
`;
